module.exports = __webpack_public_path__ + "static/img/college3.c11c41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/college3.png
// module id = HEeP
// module chunks = 1